import Banner from '../assets/images/banner.jpg'
import Tag from '../assets/images/tag.svg'
import Shield from '../assets/images/shield.png'
import Quality from '../assets/images/quality.png'
const HomePage = () => {
  return (
    <div>
      <img src={Banner} alt='banner' className='main-banner' />
      {/* <div className='my-5 motto-class'>
        <div className='container '>
          <div className='row row-motto'>
            <div className='col-md-4'>
              <div className='d-flex'>
                <div className='img'>
                  <img src={Tag} className='our-motto' />
                </div>
                <div className=''>
                  <h5>Genuine Price</h5>
                  <p>Quality products at economic price is the main motto for us</p>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='d-flex'>
                <div className='img'>
                  <img src={Quality} className='our-motto' />
                </div>
                <div className=''>
                  <h5>Best Quality</h5>
                  <p>Quality & innovation are the key behind our success</p>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='d-flex'>
                <div className='img'>
                  <img src={Shield} className='our-motto' />
                </div>
                <div className=''>
                  <h5>Safe To Use</h5>
                  <p>Crackers we offer are safe & are made from fine quality raw materials</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}
export default HomePage